export default "__VITE_ASSET__4025298e__"